define('bindingHandlers/renderComponent',[
    'lib/knockout',
    'bindingHandlers/include'
], function (ko, includeBinding) {
    'use strict';

    function delegateToInclude(method, element, valueAccessor, allBindings, viewModel, bindingContext) {
        var bindingData = ko.unwrap(valueAccessor());
        var mainTemplate = bindingData.component + '/main';
        var includeValueAccessor = function () {
            return {
                name: mainTemplate,
                data: bindingData.data
            };
        };
        includeBinding[method](element, includeValueAccessor, allBindings, viewModel, bindingContext);
    }

    ko.bindingHandlers.renderComponent = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            delegateToInclude('init', element, valueAccessor, allBindings, viewModel, bindingContext);
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var classKey = 'renderComponent-componentClass';
            var componentName = ko.unwrap(valueAccessor()).component;
            var newComponentClass = componentName + '-component';
            var oldComponentClass = ko.utils.domData.get(element, classKey);

            //the include binding will use this data to re-write template paths.
            ko.utils.domData.set(element, classKey, newComponentClass);
            viewModel[includeBinding.TEMPLATE_CONTEXT_KEY] = componentName;

            element.classList.remove(oldComponentClass);
            element.classList.add(newComponentClass);

            delegateToInclude('update', element, valueAccessor, allBindings, viewModel, bindingContext);
        }
    };

    return ko.bindingHandlers.renderComponent;
});

